const map = {
	"./Achtung.svg": 494,
	"./Fahrerhausschalter.svg": 485,
	"./Shift.svg": 830,
	"./Zeichnung_2H.svg": 782,
	"./btnClose.svg": 558,
	"./btnDown.svg": 122,
	"./btnOpen.svg": 410,
	"./btnPlatformIn.svg": 594,
	"./btnPlatformOut.svg": 533,
	"./btnTrailer.svg": 159,
	"./btnTruck.svg": 419,
	"./btnUp.svg": 905,
	"./control_mode0.svg": 131,
	"./control_mode1.svg": 762,
	"./control_mode2.svg": 137,
	"./control_mode3.svg": 392,
	"./footswitch0.svg": 666,
	"./footswitch1.svg": 35,
	"./footswitch2.svg": 296,
	"./footswitch3.svg": 689,
	"./noDown.svg": 275,
	"./noDown_Grau.svg": 255,
	"./noUeberdruck.svg": 209,
	"./noUeberdruck_Grau.svg": 261,
	"./noUp.svg": 964,
	"./noUpDown.svg": 896,
	"./noUpDown_Grau.svg": 234,
	"./noUp_Grau.svg": 446,
	"./pls_orientation0.jpeg": 773,
	"./pls_orientation1.jpeg": 110,
	"./pls_orientation2.jpeg": 171,
	"./pls_orientation3.jpeg": 892
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;